/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-cssgrid_cssgridlegacy-cssmask-setclasses !*/
!(function (e, n, t) {
  function r(e, n) {
    return typeof e === n;
  }
  function s() {
    var e, n, t, s, o, i, l;
    for (var a in w)
      if (w.hasOwnProperty(a)) {
        if (
          ((e = []),
          (n = w[a]),
          n.name &&
            (e.push(n.name.toLowerCase()),
            n.options && n.options.aliases && n.options.aliases.length))
        )
          for (t = 0; t < n.options.aliases.length; t++)
            e.push(n.options.aliases[t].toLowerCase());
        for (s = r(n.fn, "function") ? n.fn() : n.fn, o = 0; o < e.length; o++)
          (i = e[o]),
            (l = i.split(".")),
            1 === l.length
              ? (Modernizr[l[0]] = s)
              : (!Modernizr[l[0]] ||
                  Modernizr[l[0]] instanceof Boolean ||
                  (Modernizr[l[0]] = new Boolean(Modernizr[l[0]])),
                (Modernizr[l[0]][l[1]] = s)),
            C.push((s ? "" : "no-") + l.join("-"));
      }
  }
  function o(e) {
    var n = _.className,
      t = Modernizr._config.classPrefix || "";
    if ((x && (n = n.baseVal), Modernizr._config.enableJSClass)) {
      var r = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
      n = n.replace(r, "$1" + t + "js$2");
    }
    Modernizr._config.enableClasses &&
      ((n += " " + t + e.join(" " + t)),
      x ? (_.className.baseVal = n) : (_.className = n));
  }
  function i(e, n) {
    return !!~("" + e).indexOf(n);
  }
  function l() {
    return "function" != typeof n.createElement
      ? n.createElement(arguments[0])
      : x
      ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0])
      : n.createElement.apply(n, arguments);
  }
  function a(e) {
    return e
      .replace(/([a-z])-([a-z])/g, function (e, n, t) {
        return n + t.toUpperCase();
      })
      .replace(/^-/, "");
  }
  function u(e, n) {
    return function () {
      return e.apply(n, arguments);
    };
  }
  function f(e, n, t) {
    var s;
    for (var o in e)
      if (e[o] in n)
        return t === !1
          ? e[o]
          : ((s = n[e[o]]), r(s, "function") ? u(s, t || n) : s);
    return !1;
  }
  function d(e) {
    return e
      .replace(/([A-Z])/g, function (e, n) {
        return "-" + n.toLowerCase();
      })
      .replace(/^ms-/, "-ms-");
  }
  function c(n, t, r) {
    var s;
    if ("getComputedStyle" in e) {
      s = getComputedStyle.call(e, n, t);
      var o = e.console;
      if (null !== s) r && (s = s.getPropertyValue(r));
      else if (o) {
        var i = o.error ? "error" : "log";
        o[i].call(
          o,
          "getComputedStyle returning null, its possible modernizr test results are inaccurate",
        );
      }
    } else s = !t && n.currentStyle && n.currentStyle[r];
    return s;
  }
  function p() {
    var e = n.body;
    return e || ((e = l(x ? "svg" : "body")), (e.fake = !0)), e;
  }
  function m(e, t, r, s) {
    var o,
      i,
      a,
      u,
      f = "modernizr",
      d = l("div"),
      c = p();
    if (parseInt(r, 10))
      for (; r--; )
        (a = l("div")), (a.id = s ? s[r] : f + (r + 1)), d.appendChild(a);
    return (
      (o = l("style")),
      (o.type = "text/css"),
      (o.id = "s" + f),
      (c.fake ? c : d).appendChild(o),
      c.appendChild(d),
      o.styleSheet
        ? (o.styleSheet.cssText = e)
        : o.appendChild(n.createTextNode(e)),
      (d.id = f),
      c.fake &&
        ((c.style.background = ""),
        (c.style.overflow = "hidden"),
        (u = _.style.overflow),
        (_.style.overflow = "hidden"),
        _.appendChild(c)),
      (i = t(d, e)),
      c.fake
        ? (c.parentNode.removeChild(c), (_.style.overflow = u), _.offsetHeight)
        : d.parentNode.removeChild(d),
      !!i
    );
  }
  function g(n, r) {
    var s = n.length;
    if ("CSS" in e && "supports" in e.CSS) {
      for (; s--; ) if (e.CSS.supports(d(n[s]), r)) return !0;
      return !1;
    }
    if ("CSSSupportsRule" in e) {
      for (var o = []; s--; ) o.push("(" + d(n[s]) + ":" + r + ")");
      return (
        (o = o.join(" or ")),
        m(
          "@supports (" + o + ") { #modernizr { position: absolute; } }",
          function (e) {
            return "absolute" == c(e, null, "position");
          },
        )
      );
    }
    return t;
  }
  function y(e, n, s, o) {
    function u() {
      d && (delete T.style, delete T.modElem);
    }
    if (((o = r(o, "undefined") ? !1 : o), !r(s, "undefined"))) {
      var f = g(e, s);
      if (!r(f, "undefined")) return f;
    }
    for (
      var d, c, p, m, y, v = ["modernizr", "tspan", "samp"];
      !T.style && v.length;

    )
      (d = !0), (T.modElem = l(v.shift())), (T.style = T.modElem.style);
    for (p = e.length, c = 0; p > c; c++)
      if (
        ((m = e[c]),
        (y = T.style[m]),
        i(m, "-") && (m = a(m)),
        T.style[m] !== t)
      ) {
        if (o || r(s, "undefined")) return u(), "pfx" == n ? m : !0;
        try {
          T.style[m] = s;
        } catch (h) {}
        if (T.style[m] != y) return u(), "pfx" == n ? m : !0;
      }
    return u(), !1;
  }
  function v(e, n, t, s, o) {
    var i = e.charAt(0).toUpperCase() + e.slice(1),
      l = (e + " " + P.join(i + " ") + i).split(" ");
    return r(n, "string") || r(n, "undefined")
      ? y(l, n, s, o)
      : ((l = (e + " " + z.join(i + " ") + i).split(" ")), f(l, n, t));
  }
  function h(e, n, r) {
    return v(e, t, t, n, r);
  }
  var C = [],
    w = [],
    S = {
      _version: "3.6.0",
      _config: {
        classPrefix: "",
        enableClasses: !0,
        enableJSClass: !0,
        usePrefixes: !0,
      },
      _q: [],
      on: function (e, n) {
        var t = this;
        setTimeout(function () {
          n(t[e]);
        }, 0);
      },
      addTest: function (e, n, t) {
        w.push({ name: e, fn: n, options: t });
      },
      addAsyncTest: function (e) {
        w.push({ name: null, fn: e });
      },
    },
    Modernizr = function () {};
  (Modernizr.prototype = S), (Modernizr = new Modernizr());
  var _ = n.documentElement,
    x = "svg" === _.nodeName.toLowerCase(),
    b = "Moz O ms Webkit",
    P = S._config.usePrefixes ? b.split(" ") : [];
  S._cssomPrefixes = P;
  var z = S._config.usePrefixes ? b.toLowerCase().split(" ") : [];
  S._domPrefixes = z;
  var E = { elem: l("modernizr") };
  Modernizr._q.push(function () {
    delete E.elem;
  });
  var T = { style: E.elem.style };
  Modernizr._q.unshift(function () {
    delete T.style;
  }),
    (S.testAllProps = v),
    (S.testAllProps = h),
    Modernizr.addTest("cssmask", h("maskRepeat", "repeat-x", !0)),
    Modernizr.addTest("cssgridlegacy", h("grid-columns", "10px", !0)),
    Modernizr.addTest("cssgrid", h("grid-template-rows", "none", !0)),
    s(),
    o(C),
    delete S.addTest,
    delete S.addAsyncTest;
  for (var N = 0; N < Modernizr._q.length; N++) Modernizr._q[N]();
  e.Modernizr = Modernizr;
})(window, document);
